import React from 'react';
interface ArrowRightProps {
  className?: string;
  color?: string;
}
const ArrowRight = ({
  className,
  color
}: ArrowRightProps) => {
  return <svg width="25" height="25" viewBox="0 0 25 25" fill="none" className={className} data-sentry-element="svg" data-sentry-component="ArrowRight" data-sentry-source-file="ArrowRight.tsx">
      <path d="M9.00194 4.5011L16.5032 12.0024L9.00194 19.5037" stroke={color || '#2F2F2F'} strokeWidth="1.50026" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="ArrowRight.tsx" />
    </svg>;
};
export default ArrowRight;